import { CompanyService } from '@app/core';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { environment } from '@app/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FooterComponent implements OnInit {
  private companyService = inject(CompanyService);

  public readonly lastUpdate$ = this.companyService.lastUpdate$;
  public readonly copyright = environment.branding.copyright;

  ngOnInit(): void {}
}
